import React from 'react'

import { useDispatch } from 'react-redux'
import classNames from 'classnames'

import { GUEST } from 'data/users/roles'
import { actions as InvitationsActions } from 'data/invites'

import { KeyIcon, UserAddIcon } from 'components/Utils/Icons'
import SelectRoleWrapper from 'components/Utils/SelectRole/Wrapper'

import { rolesMap as userRolesMap } from 'remote/channels/roles'

const emailReg = /[^@]+@[^.]+\..+/

export type InviteRowProps = {
  email: string
  channel: any
  organizationRole: string
  onInvite: () => void
}

export default function InviteRow({
  email,
  channel,
  organizationRole,
  onInvite,
}: InviteRowProps) {
  const [popoverIsOpen, setPopoverIsOpen] = React.useState(false)
  const dispatch = useDispatch()
  const disabled = !emailReg.test(email)
  const IconClass = organizationRole === GUEST ? KeyIcon : UserAddIcon
  return (
    <SelectRoleWrapper
      roles={userRolesMap}
      onSelectRole={(role: string) => {
        dispatch(
          InvitationsActions.createInvites({
            invites: [
              {
                email,
                organizationRole,
                channelMemberships: [
                  {
                    channelId: channel.id,
                    role,
                  },
                ],
              },
            ],
          })
        )
        onInvite()
      }}
      disabled={disabled}
      position="bottom"
      align="end"
      onIsOpenChange={({ isOpen }: { isOpen: boolean }) =>
        setPopoverIsOpen(isOpen)
      }
    >
      <div
        className={classNames(
          'flexbox flexbox-align-center padding-horizontal-medium pointer transition background-shade-50-on-hover',
          {
            'background-shade-50': popoverIsOpen,
            'cursor-forbidden shade-20': disabled,
          }
        )}
        style={{ height: 40, marginTop: 2, marginBottom: 2 }}
      >
        <div>
          <IconClass className="margin-right-normal" />
          Invite <span className="font-weight-bold">{email}</span> as{' '}
          {organizationRole} in {channel.name}
        </div>
      </div>
    </SelectRoleWrapper>
  )
}
